import {useData} from "vike-react/useData";
import {DataWrapped} from "#/src/definitions/AppDefinitions";
import {ApiLivestreamData} from "#/src/definitions/ApiDefinitions";
import styled from "@emotion/styled";

const Embed = styled.iframe`
  border: none;
  overflow: hidden;
`;

export function FacebookEmbed() {
  const {data: livestreamData} = useData() as DataWrapped<ApiLivestreamData>;
  if(!livestreamData.streamer.facebookEmbed) {
    return <></>
  }
  const target = livestreamData.streamer.facebookEmbed;
  return <section className="post-social my-7" id="post">
    <div className="container-xxl">
      <div className="row">
        <div className="col-xl-12">
          <h2 className="basic-headline mb-4">Ostatnie posty</h2>
        </div>
        <div className="col-xl-6 col-lg-6">
          <Embed src={`https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F${target}&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=2867047560115920`} width="340" height="500" scrolling="no" frameBorder="0" allowFullScreen={true} allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></Embed>
        </div>
      </div>
    </div>
  </section>
}